import {
  GETFEEREPORTLIST_SUCCESS,
  GETFEEREPORTLIST_FAILED,
  RESET_GETFEEREPORTLIST,
  LOADING_GETFEEREPORTLIST,
  NETWORK_ERROR_GETFEEREPORTLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetFeeReportList = () => {
  return { type: RESET_GETFEEREPORTLIST };
};

const getFeeReportList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETFEEREPORTLIST });
  await partnerServices
    .post("getFeeReportList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getFeeReportListSuccess(res.data));
          break;
        default:
          dispatch(getFeeReportListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETFEEREPORTLIST, payload: err });
    });
};
function getFeeReportListSuccess(data) {
  return {
    type: GETFEEREPORTLIST_SUCCESS,
    payload: data,
  };
}
function getFeeReportListFailed(data) {
  return {
    type: GETFEEREPORTLIST_FAILED,
    payload: data,
  };
}

export { resetGetFeeReportList, getFeeReportList };
